export const identifiersConfig = [
  { heading: "SSN", system: "http://hl7.org/fhir/sid/us-ssn" },
  { heading: "HICN", system: "http://hl7.org/fhir/sid/us-medicare" },
  { heading: "MBI", system: "http://hl7.org/fhir/sid/us-mbi" },
  { heading: "MRN", code: "MR" },
  { heading: "CPIN", system: "cpin" },
  { heading: "HSID", code: "healthSafeId" }
  // { heading: "Coverage Family ID", code: "COV", system: "familyID" },
  // { heading: "Coverage System ID", code: "COV", system: "origSysId" }
];
